import { FormBuilderContainer } from '@wrisk/ui-components'
import React, { FunctionComponent, useMemo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { TExtends } from '../../infrastructure/internationalisation'
import { ActionBar } from '../organisms/form'
import { FormErrorsPortal, FormFooter, FormSections } from './components'
import { defaultOptions, ERROR_MESSAGE_CLASS, INPUT_SECTION_CLASS } from './options'
import { FormBuilderProps } from './types'

export const FormErrors: FunctionComponent<FormBuilderProps> = ({
  id,
  footerText,
  data,
  inputs,
  onSubmit,
  onSkip,
  loading,
  options = {},
  tKey,
  t,
  ...props
}) => {
  const finalOptions = useMemo(() => ({ ...defaultOptions, ...options }), [])

  const form = useForm({
    values: data,
    shouldUnregister: finalOptions.shouldUnregister,
  })

  return (
    <FormProvider {...form}>
      <FormBuilderContainer
        data-testid={id}
        onSubmit={form.handleSubmit(onSubmit)}
        width={1}
        {...props}
      >
        <FormSections
          inputs={inputs}
          options={finalOptions}
          sectionClassName={INPUT_SECTION_CLASS}
          errorClassName={ERROR_MESSAGE_CLASS}
          tKey={TExtends(tKey, 'inputs')}
          t={t}
        />
        <FormFooter tKey={tKey} tName={footerText} t={t} />
        <ActionBar tKey={tKey} loading={loading} onDismiss={onSkip} />
      </FormBuilderContainer>
      <FormErrorsPortal
        tKey={tKey}
        t={t}
        scrollToClass={INPUT_SECTION_CLASS}
        errorClass={ERROR_MESSAGE_CLASS}
      />
    </FormProvider>
  )
}
